// src/features/eventos/hooks/useEventosSearchSort.js
import { useMemo, useState } from "react";
import { buildSearchText, norm, sortEventos } from "../domain/eventosListUtils";

// El servidor ya filtra por Pendientes/Pasados (ver useEventosList); aquí
// solo queda aplicar la búsqueda de texto y el orden.
export function useEventosSearchSort(eventos) {
    const [busqueda, setBusqueda] = useState("");
    const [orden, setOrden] = useState("fechaAsc");

    const eventosFiltrados = useMemo(() => {
        const q = norm(busqueda).trim();
        if (!q) return eventos || [];

        const tokens = q.split(/\s+/).filter(Boolean);

        return (eventos || []).filter((ev) => {
            const text = buildSearchText(ev);
            return tokens.every((t) => text.includes(t));
        });
    }, [busqueda, eventos]);

    const eventosOrdenados = useMemo(() => {
        return sortEventos(eventosFiltrados, orden);
    }, [eventosFiltrados, orden]);

    return {
        busqueda,
        setBusqueda,
        orden,
        setOrden,
        eventosFiltrados,
        eventosOrdenados,
    };
}

